import React from 'react';

import { clsx } from 'clsx';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';

import { PLANETS } from './constants';

import styles from './CollectionBlock.scss';

const CollectionBlock = () => {
  const { isDesktop } = useLayoutContext();

  return (
    <div id="collection-block" className={styles.collectionBlock}>
      <div className={styles.planets}>
        {PLANETS.map((planet) => {
          if (planet.id === 8 && isDesktop) {
            return <div key={planet.id} />;
          }

          return (
            <img
              key={planet.id}
              className={clsx(styles.planet, styles[`num${planet.id}`])}
              src={planet.src}
              alt="planet"
            />
          );
        })}
      </div>

      <div className={styles.title}>
        <FadeIn className={styles.titleThin} delay={1}>
          <span>The collection</span>
        </FadeIn>
        <FadeIn className={styles.titleThin} delay={1.5}>
          <span>of planets is limited.</span>
        </FadeIn>
        <FadeIn delay={2}>
          <span>Discover yours</span>
        </FadeIn>
      </div>
    </div>
  );
};

export default CollectionBlock;
